// Canonical layout breakpoints (px). Single source of truth for the JS side of
// the responsive layout — imported by App.vue (header wrap) and views/Home.vue
// (dashboard two-column split).
//
// These MUST stay in sync with the SCSS variables in styles/mixins.scss
// ($mobile-width / $tablet-width / $two-col-landscape-min), which own the
// build-time media queries. SCSS can't read these values at build time, so the
// two sides are kept aligned by convention — change both together.
export const MOBILE_WIDTH = 450;
export const TABLET_WIDTH = 800;
export const TWO_COL_LANDSCAPE_MIN = 560;
